import React from 'react'
import Hero from './Hero/Hero'
import FeaturePowerhouse from './FeaturePowerhouse/FeaturePowerhouse'
import SocialSamples from './SocialSamples/SocialSamples'
import ComparisonSection from './ComparisonSection/ComparisonSection'
import Pricing from './Pricing/Pricing'

const Home = () => {
  return (
    <div>
      <Hero/>
      <FeaturePowerhouse/>
      <SocialSamples/>
      <ComparisonSection/>
      <Pricing/>
    </div>
  )
}

export default Home
